import DropdownPicker from '../ui/DropdownPicker';

const CLEAR_KEY = '';

export function formatTimeLabel(value) {
  const [h, m] = value.split(':').map(Number);
  return `${h % 12 || 12}:${String(m).padStart(2, '0')} ${h < 12 ? 'AM' : 'PM'}`;
}

const GRID_TIMES = Array.from({ length: 48 }, (_, i) => {
  const h = String(Math.floor(i / 2)).padStart(2, '0');
  return `${h}:${i % 2 ? '30' : '00'}`;
});

function TimeSelect({ value, onChange, placeholder = 'Select time', defaultHighlight = '12:00', disabled = false, error = false }) {
  const times = value && !GRID_TIMES.includes(value) ? [...GRID_TIMES, value].sort() : GRID_TIMES;
  const options = [{ key: CLEAR_KEY, label: 'No time' }, ...times.map(t => ({ key: t, label: formatTimeLabel(t) }))];

  return (
    <DropdownPicker
      options={options}
      value={value}
      onChange={key => onChange(key === CLEAR_KEY ? null : key)}
      placeholder={placeholder}
      defaultHighlightKey={defaultHighlight}
      width="w-full"
      variant="form"
      borderClass={error ? 'border-secondary-red' : undefined}
      disabled={disabled}
    />
  );
}

export default TimeSelect;